const Production: IConfig = {
    StripeUrl: "https://dhs-payment-892b3cdec73f.herokuapp.com",
    MessagesUrl: "https://defined-cleaning.herokuapp.com/api/v1/messaging",
    ApiBaseUrl: "https://dhs-backend-7eeabce30221.herokuapp.com/api/v1",
    StripePublishableKey: "pk_live_ydmLXp2GB54LeZHh3TQ4Zwt1",
    PaymentSuccessfulReturnUrl: "https://payment.thedefinedcrm.com",    
    isDevelopment: false
}

const Debug:IConfig = {
    StripeUrl: "http://localhost:3456",
    MessagesUrl: "http://localhost:4000/api/v1/messaging",
    ApiBaseUrl: "http://localhost:4000/api/v1",
    StripePublishableKey: "pk_test_51Rfp18R0HTLAzD8ESPjqiuVPCmDrcXAq1BVVXgv6y9d60AU404DdadBv4ZhWlC76ermb4WUuaevUJPNJRKbVAvrn003UMcbr0n",
    PaymentSuccessfulReturnUrl: "http://localhost:3001",
    isDevelopment: true
}

type IConfig = {
    StripeUrl: string,
    MessagesUrl: string,
    ApiBaseUrl: string,
    StripePublishableKey: string,
    PaymentSuccessfulReturnUrl: string,
    isDevelopment: boolean
}

export const Config = {
    Env: Production
}
